/** Полоска чипов «статус: количество» — для карточек телефонов/моделей.
 *  Порядок ФИКСИРОВАННЫЙ и одинаковый на всех карточках (даже при нулях),
 *  чтобы глаз сравнивал карточки по позициям: В работе / Прогрев / Бан /
 *  Выключение. Хьюман и «без статуса» — только когда есть. */
const ALWAYS = ['В работе', 'Прогрев', 'Бан', 'Выключение'] as const;
/** Без архивных: карточки телефонов показывают только живые статусы. */
const ACTIVE_ONLY = ['В работе', 'Прогрев'] as const;

export function StatusStrip({ byStatus, hideArchived = false }: {
  byStatus: Record<string, number>;
  hideArchived?: boolean;
}) {
  const human = byStatus['Хьюман'] ?? 0;
  const none = byStatus['—'] ?? 0;
  return (
    <div className="status-strip">
      {(hideArchived ? ACTIVE_ONLY : ALWAYS).map((s) => {
        const n = byStatus[s] ?? 0;
        return (
          <span
            key={s}
            className={`status-chip status-${s.replace(' ', '_')}`}
            style={n === 0 ? { opacity: 0.35 } : undefined}
          >
            {s}: {n}
          </span>
        );
      })}
      {human > 0 && <span className="status-chip status-Хьюман">Хьюман: {human}</span>}
      {!hideArchived && none > 0 && <span className="status-chip status-none">—: {none}</span>}
    </div>
  );
}
